import { TOGGLE_DRAWER } from "../actions/constants";

const defaultState = {
    drawerOpen: true
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case TOGGLE_DRAWER:
            return { ...state, drawerOpen: (action.payload !== null) ? action.payload : !state.drawerOpen};
        default:
            return state;
    }
};